module.exports = __webpack_public_path__ + "img/z5.af4ce4cd.png";